module.exports = __webpack_public_path__ + "img/arrow-up-right.f4c0ae4b.svg";